import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AddCodeReviewComponent } from 'src/app/AppBaseComponents/code-review-component/add-code-review/add-code-review.component';
import { CodeReviewModel } from 'src/app/Models/code-review-model';
import { PaginationModel } from 'src/app/Models/pagination-model';
import { CodeReviewService } from 'src/app/Services/code-review.service';
import { SharedService } from 'src/app/Services/shared.service';

@Component({
  selector: 'ze-code-review-list-view',
  templateUrl: './code-review-list-view.component.html',
  styleUrls: ['./code-review-list-view.component.scss']
})
export class CodeReviewListViewComponent implements OnInit {

  codeReviews: CodeReviewModel[];
  projectId: string;
  public paginationPage: PaginationModel;
  pageSize = 10;
  currentPage = 0;
  totalPages: number = 0;

  constructor(private codeReviewService: CodeReviewService,
    private sharedService: SharedService,
    public dialog: MatDialog) {
      this.onChangePage = this.onChangePage.bind(this);
  }

  onChangePage($event) {
    this.sharedService.loaderHide.emit(true);
    this.getCodeReviews($event);
  }

  ngOnInit() {
    this.sharedService.loaderHide.emit(true);
    this.projectId = localStorage.getItem("projectId");
    this.getCodeReviews(this.currentPage);
  }

  getCodeReviews(page: number) {
    let data = { size: this.pageSize, page: page };
    this.codeReviewService.getCodeReviewsByProjectId(this.projectId, data).subscribe(data => {
      this.codeReviews = data["data"][0];
      this.totalPages = data["data"][1];
      this.currentPage = data["data"][2];
      this.paginationPage = { size: this.totalPages, currentPage: this.currentPage }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.sharedService.loaderHide.emit(false);
    });
  }

  openAddCodeReviewDialog(): void {
    const dialogRef = this.dialog.open(AddCodeReviewComponent, {
      width: '30%',
      height: '63%',
      disableClose: true,
      data: {
        projectId: this.projectId,
      },
      backdropClass: 'overlay-backdrop-dark-class',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sharedService.loaderHide.emit(true);
        this.getCodeReviews(0);
      }
    });
  }

}
